import React, {FC, memo} from 'react';

// import messages from './messages';
import { SingleEvent } from '../../../../models/eventItem';
// Import React Player
import ReactPlayer from 'react-player';
import { getPublicUrl } from '../../../../utils/ImageCacheService';
import parse from 'html-react-parser';
import styled from 'styled-components';
import messages from '../messages';
import P from '../../../Paragraph';
import { FormattedMessage } from 'react-intl';
import { formatDatefromString, formatTime } from '../../../../utils/date';
import Row from '../../../Layout/Row';
import Col4 from '../../../Layout/Grid/Col4';

interface IEventAllDetails {
    item: SingleEvent;
}

const Details: FC<IEventAllDetails> = ({item}) => {

    return (
        <>
            {item.video_link ? 
                <Wrapper>
                  <ReactPlayer url={item.video_link} width='100%' />
                </Wrapper>
                : item.image ? <Wrapper><img src={getPublicUrl(item.file_name)} alt={item.title} /></Wrapper> 
            : null}

            {item.description ? 
                <Wrapper >
                    {parse(`${item.description}`)}
                </Wrapper>
            : null}

            <Wrapper>
                <Row>
                    {item.type ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventType} />:</P>
                            <span>{item.type}</span>
                        </Col4>
                    : null}
                    {item.event_venue ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventVenue} />:</P>
                            <span>{item.event_venue}</span>
                        </Col4>
                    : null}
                     {item.city ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventCity} />:</P>
                            <span>{item.city}</span>
                        </Col4>
                    : null}
                    {item.address ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventAddress} />:</P>
                            <span>{item.address}</span>
                        </Col4>
                    : null}
                    {item.date ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventDate} />:</P>
                            <span>{formatDatefromString(item.date)}</span>
                        </Col4>
                    : null}
                    {item.registration_fee ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventRegFee} />:</P>
                            <span>{item.registration_fee === '0' ? 'Besplatno' : item.registration_fee + ' ' + item.currency}</span>
                        </Col4>
                    : null}
                     {item.start_time || item.end_time ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventTime} />:</P>
                            <span>{item.start_time && item.end_time ? formatTime(item.start_time) + ' - ' + formatTime(item.end_time) : item.start_time ? formatTime(item.start_time) : item.end_time ? formatTime(item.end_time) : null}</span>
                        </Col4>
                    : null}
                    {item.max_participants ?
                        <Col4>
                            <P><FormattedMessage {...messages.EventMaxAttend} />:</P>
                            <span>{item.max_participants}</span>
                        </Col4>
                    : null}
                    {item.payment ?
                        <Col4>
                            <P><FormattedMessage {...messages.Payment} />:</P>
                            <span>{item.payment === 'invoice' ? 'Unapred' : item.payment === 'cash-on-delivery' ? 'Nakon realizacije događaja' : item.payment === 'cash-before-delivery' ? 'Na licu mesta' : ''}</span>
                        </Col4>
                    : null}
                </Row>
            </Wrapper>


        </>
    )
}

const Wrapper = styled.div`
    margin-bottom: 30px;
    span {
        font-family: "Gilroy-Medium";
    }
    .ql-video {
        max-width: 100%;
    }

`;


export default memo(Details);